<template>
  <div
    id="airportReserveModal"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">
            預約單詳細資料 - 機場接送
          </h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="airport-detail-grid">
            <!-- 1. 預約單狀態 -->
            <div class="info-block">
              <h4 class="block-title">預約單狀態</h4>
              <div class="info-item">
                <span class="label">訂單狀態：</span>
                <span class="value">{{ orderStateText }}</span>
              </div>
              <div class="info-item">
                <span class="label">預約單號：</span>
                <span class="value">{{ vx_billInfo.orderId || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">建立時間：</span>
                <span class="value">
                  {{
                    vx_billInfo.createTime || vx_billInfo.createdAt
                      ? formatDateTime(
                          vx_billInfo.createTime || vx_billInfo.createdAt,
                        )
                      : '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">預約時間：</span>
                <span class="value">
                  {{ formatDateTime(vx_billInfo.reservationTime) || '無' }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">{{ finishTimeLabel }}：</span>
                <span class="value">
                  {{ formatDateTime(vx_billInfo.finishTime) || '無' }}
                </span>
              </div>
            </div>

            <!-- 2. 聯絡資訊 -->
            <div class="info-block">
              <h4 class="block-title">聯絡資訊</h4>
              <div class="info-item">
                <span class="label">乘客姓名：</span>
                <span class="value">{{ contactName || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">行動電話：</span>
                <span class="value">{{ contactMobile || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">聯絡電話：</span>
                <span class="value">{{ contactPhone || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">Email：</span>
                <span class="value">{{ contactEmail || '無' }}</span>
              </div>
            </div>

            <!-- 3. 航班資訊 -->
            <div class="info-block">
              <h4 class="block-title">航班資訊</h4>
              <div class="info-item">
                <span class="label">接送服務：</span>
                <span class="value">{{ airportServiceTypeText || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">班機編號：</span>
                <span class="value">
                  {{ vx_billInfo.flightNumber || '無' }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">航站：</span>
                <span class="value">{{ vx_billInfo.terminal || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">起飛/抵達時間：</span>
                <span class="value">{{ formatFlightTime || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">是否要舉牌：</span>
                <span class="value">{{ signBoardText || '無' }}</span>
              </div>
            </div>

            <!-- 4. 司機資訊 -->
            <div class="info-block">
              <h4 class="block-title">司機資訊</h4>
              <template v-if="hasDriverInfo">
                <div class="info-item">
                  <span class="label">司機呼號：</span>
                  <span class="value">
                    {{ driverInfoSafe.callNumber || '無' }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">車牌號碼：</span>
                  <span class="value">
                    {{ driverInfoSafe.licence || '無' }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">車款：</span>
                  <span class="value">
                    {{ driverInfoSafe.carBrand || '無' }}
                  </span>
                </div>
              </template>
              <div v-else class="info-item info-item-center">
                <span class="value">無司機接單</span>
              </div>
            </div>

            <!-- 5. 共乘資訊 (乘客1) -->
            <div
              class="info-block"
              v-if="
                vx_billInfo.additionalPickupPoints &&
                vx_billInfo.additionalPickupPoints[0]
              "
            >
              <h4 class="block-title">共乘資訊 (乘客1)</h4>
              <div class="info-item">
                <span class="label">乘客姓名：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[0].passengerName || '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">行動電話：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[0].passengerMobile ||
                    '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">聯絡電話：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[0].passengerPhone || '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">地址：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[0].pickupAddress || '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">備註：</span>
                <span class="value">
                  {{ vx_billInfo.additionalPickupPoints[0].pickupNote || '無' }}
                </span>
              </div>
            </div>

            <!-- 8. 共乘資訊 (乘客2) -->
            <div
              class="info-block"
              v-if="
                vx_billInfo.additionalPickupPoints &&
                vx_billInfo.additionalPickupPoints[1]
              "
            >
              <h4 class="block-title">共乘資訊 (乘客2)</h4>
              <div class="info-item">
                <span class="label">乘客姓名：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[1].passengerName || '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">行動電話：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[1].passengerMobile ||
                    '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">聯絡電話：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[1].passengerPhone || '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">地址：</span>
                <span class="value">
                  {{
                    vx_billInfo.additionalPickupPoints[1].pickupAddress || '無'
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">備註：</span>
                <span class="value">
                  {{ vx_billInfo.additionalPickupPoints[1].pickupNote || '無' }}
                </span>
              </div>
            </div>

            <!-- 6. 搭車資訊 -->
            <div class="info-block">
              <h4 class="block-title">搭車資訊</h4>
              <div class="info-item">
                <span class="label">搭車日期：</span>
                <span class="value">
                  {{ formatDateTime(vx_billInfo.reservationTime) || '無' }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">車型：</span>
                <span class="value">{{ vx_billInfo.vehicleType || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">接送地址：</span>
                <span class="value">{{ vx_billInfo.onLocation || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">搭車人數：</span>
                <span class="value">{{ passengerCount || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">需要幾台：</span>
                <span class="value">{{ vx_billInfo.cars || '無' }}台</span>
              </div>
              <div class="info-item">
                <span class="label">大行李件數：</span>
                <span class="value">{{ vx_billInfo.luggageBig || 0 }}件</span>
              </div>
              <div class="info-item">
                <span class="label">小行李件數：</span>
                <span class="value">{{ vx_billInfo.luggageSmall || 0 }}件</span>
              </div>
              <div class="info-item">
                <span class="label">無菸車隊：</span>
                <span class="value">{{ noSmokingText || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">兒童座椅：</span>
                <span class="value">{{ childSeatText || '無' }}</span>
              </div>
              <div class="info-item">
                <span class="label">乘客備註：</span>
                <span class="value">
                  {{ vx_billInfo.passengerNote || '無' }}
                </span>
              </div>
            </div>

            <!-- 7. 費用資訊 -->
            <div class="info-block">
              <h4 class="block-title">費用資訊</h4>
              <template v-if="isOrderCompleted">
                <div class="info-item">
                  <span class="label">付款方式：</span>
                  <span class="value">
                    {{ vx_billInfo.paymentMethod || '無' }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">金額：</span>
                  <span class="value">
                    {{ formatAmount || '無' }}
                  </span>
                </div>
              </template>
              <div
                v-else-if="!hasDriverInfo"
                class="info-item info-item-center"
              >
                <span class="value">無司機接單</span>
              </div>
              <div v-else class="info-item info-item-center">
                <span class="value">訂單未結束</span>
              </div>
            </div>
          </div>
          <hr />
          <Bottom ref="bottom" />
          <hr />
          <MessageTable />
          <!-- 取消原因 -->
          <div v-if="cancelReason" style="margin-left: 1rem">
            <span class="fontSize20 title-color">取消原因：</span>
            <span class="fontSize20">{{ cancelReason }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Bottom from '../Bottom.vue'
import MessageTable from '../MessageTable.vue'
import dayjs from 'dayjs'

export default {
  components: {
    Bottom,
    MessageTable,
  },
  computed: {
    ...mapState('reserveModal', {
      vx_billInfo: 'billInfo',
      vx_driverInfo: 'driverInfo',
      vx_openAt: 'openAt',
    }),
    orderStateText() {
      // 優先檢查取消狀態
      if (this.vx_billInfo.driverCancel) return '司機取消'
      if (this.vx_billInfo.passengerCancel) return '乘客取消'

      // 再檢查訂單狀態
      const result = this.vx_billInfo.result
      if (result === 0) return '已配對'
      if (result === 1) return '已載客'
      if (result === 2) return '已完成'
      if (result === 3) return '未配對完'
      if (result === 4) return '等候乘客選擇司機'
      return '尚未有司機接單'
    },
    contactName() {
      return this.vx_billInfo.contactName || this.vx_billInfo.passengerName
    },
    contactMobile() {
      return this.vx_billInfo.contactMobile || this.vx_billInfo.passengerPhone
    },
    contactPhone() {
      return this.vx_billInfo.contactPhone
    },
    contactEmail() {
      return this.vx_billInfo.contactEmail
    },
    airportServiceTypeText() {
      const type = this.vx_billInfo.airportServiceType
      if (type === 1) return '接機'
      if (type === 2) return '送機'
      return null
    },
    formatFlightTime() {
      if (this.vx_billInfo.flightTime) {
        return dayjs(this.vx_billInfo.flightTime).format('HH:mm')
      }
      return null
    },
    signBoardText() {
      if (this.vx_billInfo.needSignBoard) {
        return `是 (${this.vx_billInfo.signBoardName || '無'})`
      }
      return '否'
    },
    hasDriverInfo() {
      return this.vx_driverInfo && Object.keys(this.vx_driverInfo).length > 0
    },
    driverInfoSafe() {
      return this.vx_driverInfo || {}
    },
    passengerCount() {
      if (
        this.vx_billInfo.passengerCount !== null &&
        this.vx_billInfo.passengerCount !== undefined
      ) {
        return this.vx_billInfo.passengerCount
      }
      if (
        this.vx_billInfo.seatNumber !== null &&
        this.vx_billInfo.seatNumber !== undefined
      ) {
        return this.vx_billInfo.seatNumber
      }
      return null
    },
    noSmokingText() {
      if (this.vx_billInfo.noSmoking === true) return '是'
      if (this.vx_billInfo.noSmoking === false) return '否'
      return null
    },
    childSeatText() {
      const infant = this.vx_billInfo.childSeatInfant || 0
      const toddler = this.vx_billInfo.childSeatToddler || 0
      const booster = this.vx_billInfo.childSeatBooster || 0
      const parts = []
      if (infant > 0) parts.push(`0-1歲 (${infant}件)`)
      if (toddler > 0) parts.push(`1-3歲 (${toddler}件)`)
      if (booster > 0) parts.push(`4-7歲 (${booster}件)`)
      return parts.length > 0 ? parts.join(', ') : '無'
    },
    formatAmount() {
      if (
        this.vx_billInfo.amount !== null &&
        this.vx_billInfo.amount !== undefined
      ) {
        return `NT$ ${this.vx_billInfo.amount.toLocaleString()}`
      }
      return null
    },
    finishTimeLabel() {
      // 如果訂單已取消，顯示「取消時間」，否則顯示「下車時間」
      if (this.vx_billInfo.driverCancel || this.vx_billInfo.passengerCancel) {
        return '取消時間'
      }
      return '下車時間'
    },
    isOrderCompleted() {
      // 訂單已完成（result === 2）
      return this.vx_billInfo.result === 2
    },
    cancelReason() {
      // 優先處理乘客取消
      if (this.vx_billInfo.passengerCancel) {
        // 官網乘客按會固定只回這四個字 如果有跑掉要跟後端溝通一下是否被更改了
        if (this.vx_billInfo.passengerCancel === '乘客取消') {
          return '乘客取消--官網取消'
        }
        return this.vx_billInfo.passengerCancel
      }
      // 再處理司機取消
      if (this.vx_billInfo.driverCancel) {
        return this.vx_billInfo.driverCancel
      }
      return null
    },
  },
  methods: {
    ...mapActions('reservation', {
      vx_fetchReserveList: 'fetchList',
    }),
    formatDateTime(date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm')
      }
      return null
    },
    openModal() {
      /* 初始化modal中state的內容 */
      if (this.$refs.bottom && this.$refs.bottom.initNote) {
        this.$refs.bottom.initNote()
      }
      $('#airportReserveModal').modal({ backdrop: 'static', keyboard: true })
    },
    closeModal() {
      /* 初始化modal中state的內容 */
      $('#airportReserveModal').modal('hide')
      /* 更新modal外列表的資料 */
      if (this.vx_openAt === '預約單') {
        this.vx_fetchReserveList()
      }
    },
  },
}
</script>

<style scoped>
.airport-detail-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.info-block {
  padding: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
}
.block-title {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #333;
  border-bottom: 2px solid #409eff;
  padding-bottom: 0.5rem;
}
.info-item {
  margin-bottom: 0.8rem;
  font-size: 1.6rem;
  line-height: 1.8;
}
.info-item .label {
  font-weight: bold;
  color: #666;
  margin-right: 0.2rem;
}
.info-item .value {
  color: #333;
}
.info-item-center {
  text-align: center;
}
/* 取消原因 */
.title-color {
  font-weight: bold;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/reserveModal/Airport/index.vue